import React from 'react'
import { useSelector } from 'react-redux'
import { Row, Col } from 'antd'
import moment from 'moment'

import { ApplicationState } from 'src/store'
import { Title, Text } from 'src/components/Ant'

import { WrapSectionHeader } from './styles'

function SectionHeader() {
  const {
    reports: {
      reportsResources: {
        R3Data: { data },
        R3Header: { data: header }
      }
    }
  } = useSelector((state: ApplicationState) => ({
    reports: state.reports
  }))

  let startedDate = header.length > 0 ? header[0].started_date : null
  let endedDate = header.length > 0 ? header[0].ended_date : null

  data.forEach((item: any) => {
    if (item.receipt_date < startedDate) {
      startedDate = item.receipt_date
    }
    if (item.receipt_date > endedDate) {
      endedDate = item.receipt_date
    }
  })

  const period =
    data.length <= 0
      ? ' - '
      : `${moment(moment.unix(startedDate).utc().format('YYYYMMDD')).format(
          'DD/MM/YYYY'
        )} - ${moment(moment.unix(endedDate).utc().format('YYYYMMDD')).format(
          'DD/MM/YYYY'
        )}`

  return (
    <WrapSectionHeader>
      <Row>
        <Col span={24}>
          <Title id="subtitle" level={4} title="web.report.3.header.title" />
        </Col>
      </Row>
      <Row>
        <Col span={16}>
          <Text colon id="header" title="web.report.3.header.organization">
            <span id="value">
              {(header[0] && header[0].organization_name) || ' - '}
            </span>
          </Text>
        </Col>
        <Col span={8}>
          <Text colon id="header" title="web.report.3.header.period">
            <span id="value">{period}</span>
          </Text>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Text colon id="header" title="web.report.3.header.participante_name">
            <span id="value">
              {(header[0] && header[0].participant_name) || ' - '}
            </span>
          </Text>
        </Col>
      </Row>
    </WrapSectionHeader>
  )
}

export default SectionHeader
